import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapSingle } from './normalize'
import type { ProgramConfig } from '../../types/apiModels'

export default async function getProgramConfig({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}) {
  const response = await apiClient.get(endpoints.programConfig, { params: { farmId }, signal })
  return unwrapSingle<ProgramConfig>(response)
}
